import React, { useState, useEffect } from 'react'
import { Modal } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { TableBrowseCustomers } from "src/app/pages/order/TableBrowseCustomers"
import { useAppDispatch, useAppSelector } from 'src/redux/hooks'
import { orderSelector, setCustomerList, setNumberUrls } from 'src/redux/slices/orderSlices'
import axios from 'axios'
import { getCustomer, getCustomerDt } from 'src/api/modules/getdatalist'

type Props = {
    show: boolean
    setShow: (value: boolean) => void
    onChoose: (data: any) => void
}

const BrowserCustomer: React.FC<Props> = ({
    show,
    setShow,
    onChoose
}) => {
    const {t} = useTranslation()
    const dispatch = useAppDispatch()

    const {customerFilter} = useAppSelector(orderSelector)

    const [fullCustomer, setFullCustomer] = useState<any[]>([])
    const [loadingpage, setLoadingPage] = useState(false)
    const [numberURL, setNumberURL] = useState([])

    useEffect(() => {
        const getData = setTimeout(async () => {
          await getCustomer(customerFilter?.customer_code ?? '', customerFilter?.name ?? '').then(
            (res: any) => {
              setFullCustomer(res.data.data.data)
              dispatch(setCustomerList(res.data.data.data))
              setNumberURL(res.data.data.links)
              dispatch(setNumberUrls(res.data.data.links))
            }
          )
        }, 1000)
    
        return () => clearTimeout(getData)
    }, [customerFilter])

    const paginateNumber = async (number: any) => {
        setLoadingPage(true)
        const customer_code = customerFilter?.customer_code ?? ''
        const name = customerFilter?.name ?? ''
        const res = await axios.get(`${number}&customer_code=${customer_code}&name=${name}`, {
            headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
            Accept: 'application/json',
            'Access-Control-Allow-Origin': '*',
            },
        })
        setFullCustomer(res.data.data.data)
        dispatch(setCustomerList(res.data.data.data))
        setNumberURL(res.data.data.links)
        dispatch(setNumberUrls(res.data.data.links))
        setLoadingPage(false)
    }

    const loadDetailCust = async (item: any) => {
        try {
            let {data} = await getCustomerDt(item?.customer_code)
            onChoose({
                ...item,
                user: data?.data?.user,
            })
        }catch(e: any) {
            onChoose(item)
        }
    }

    return <>
        <Modal
            show={show}
            onHide={() => setShow(false)}
            centered
            backdrop='static'
            keyboard={false}
            size='lg'
        >
            <Modal.Header closeButton>
                <Modal.Title>{t('Browse')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <TableBrowseCustomers
                    customers={fullCustomer}
                    paginateNumber={paginateNumber}
                    numberURL={numberURL}
                    onSelectCustomer={(item) => {
                        loadDetailCust(item)
                    }}
                />
            </Modal.Body>
        </Modal>
    </>
}

export default BrowserCustomer